import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const headerPadding = {
    paddingTop: isMobile ? '80px' : '3rem',
    paddingBottom: '3rem'
  };

  return (
    <>
      {/* Page Header */}
      <section className="section bg-theme-dark tc-light">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="page-header" style={headerPadding}>
                <h1 className="title title-xl">Barangay Services</h1>
                <p className="lead">
                  Comprehensive digital services to meet all your barangay needs. Access these services through our
                  desktop and mobile applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Barangay Services Section */}
      <section className="section bg-light" style={{ paddingTop: '30px' }}>
        <div className="container">
          <div className="section-head text-center wide-auto-sm">
            <h2 className="title title-s4">Our Services</h2>
            <p>
              All barangay services available through EBARANGAY platform
            </p>
          </div>

          <div className="nk-block">
            <div className="row gutter-vr-40px">
              <div className="col-lg-4 col-md-6">
                <div className="service-card h-100 text-center">
                  <div className="service-icon mx-auto">
                    <em className="fas fa-certificate"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Barangay Clearances</h4>
                  <p>
                    Issuance of barangay clearance, certificate of indigency, or certificate of residency for
                    residents' official transactions.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card h-100 text-center">
                  <div className="service-icon mx-auto">
                    <em className="fas fa-store"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Business Permits</h4>
                  <p>
                    Application and renewal of barangay business permits for local establishments and entrepreneurs.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card h-100 text-center">
                  <div className="service-icon mx-auto">
                    <em className="fas fa-book"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Blotters</h4>
                  <p>
                    Recording of incidents, complaints, or community disputes reported to the barangay for
                    documentation and resolution.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card h-100 text-center">
                  <div className="service-icon mx-auto">
                    <em className="fas fa-exclamation-circle"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Complaints</h4>
                  <p>
                    Formal filing of grievances or issues by residents for mediation and barangay action.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card h-100 text-center">
                  <div className="service-icon mx-auto">
                    <em className="fas fa-calendar-check"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Special Permits</h4>
                  <p>
                    Application for special event or activity permits within the barangay (e.g., public gatherings,
                    fiestas, or road closures).
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card h-100 text-center">
                  <div className="service-icon mx-auto">
                    <em className="fas fa-paw"></em>
                  </div>
                  <h4 className="title title-sm mb-3">Pet Registrations</h4>
                  <p>
                    Registration of household pets for barangay records, vaccination monitoring, and issuance of pet
                    identification.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section bg-theme tc-light">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="title title-lg mb-3">Start Using EBARANGAY Services Today</h2>
              <p className="lead mb-4">
                Download the app and access all barangay services from your mobile device.
              </p>
              <div>
                <a
                  href="https://play.google.com/store"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg btn-grad btn-grad-alternet btn-round"
                >
                  <em className="fab fa-google-play me-2"></em>
                  Download on Google Play
                </a>
                <Link to="/contact" className="btn btn-lg btn-outline btn-white btn-round ms-2">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
